import React from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <div className="relative min-h-screen w-full flex items-center justify-center overflow-hidden">
      
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-bottom bg-no-repeat"
        style={{ backgroundImage: "url('/images/home/blackbanner.jpg')" }}
      ></div>

      {/* Black overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-70"></div>

      {/* Content */}
      <div className="relative text-center px-4 z-10">
        <h1 className="text-5xl md:text-6xl font-bold mb-4 text-white">Welcome to SM6</h1>

        <p className="text-xl md:text-xl mb-6 text-white">
          Leading architect and interior designer providing 
          <span className="md:block">
            turnkey solution for commercial spaces from Bengaluru.
          </span>
        </p>

        <Link to="/services">
          <button className="bg-theme-color px-6 py-3 rounded-lg hover:bg-red-700 transition text-white font-bold">
            Explore Now
          </button>
        </Link>
      </div>

    </div>
  );
}
